define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {
	const merchAdminRoles = ['Business Plan Administrator'];
	const merchCreatorRoles = ['Business Plan Creator'];
	const merchProductVersionParticipant = ['Merch Product Version Participant'];
	const teamManager = ['Team Manager'];

	csiAccess.addViewRoles({
		"MerchandisingViews":{
			"Merchandising": {
				"MerchPlanWithForm":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchPlan":{
			"ManagedCrew":{
				"CreateCrew":access(full(teamManager)),
				"RemoveCrew":access(full(teamManager))
			},
			"Versions": {
				"NewMerchSeason":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchSeason":{
			"Target": {
				"NewFolderNoForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewFolderWithForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewFolderVersionParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles))
			},
			"TargetSecondaries": {
				"NewSecondaryFrom":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchFolder":{
			"ManagedCrew":{
				"CreateCrew":access(full(teamManager)),
				"RemoveCrew":access(full(teamManager))
			},
			"Versions": {
				"NewFolderVersionBySeason":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchFolderVersion":{
			"TargetFolders": {
				"NewFolderNoForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewFolderWithForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewFolderVersionByParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles))
			},
			"TargetCollections": {
				"NewCollectionNoForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewCollectionWithForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewCollectionVersionByParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles))
			},
			"TargetSecondaries": {
				"NewSecondaryFrom":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchCollection":{
			"Versions": {
				"NewCollectionVersionBySeason":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchCollectionVersion":{
			"Target": {
				"NewProductVersion":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewProductVersionsFromExistingVersions":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewProductByParentVersionAndStyle":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewProductByParentVersionAndMaterial":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewProductCarryoverByParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewProductCarryoverWithStyleByParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewProductReplenishmentByParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"Copy":access(full(merchAdminRoles), full(merchCreatorRoles)),
				"Delete":access(full(merchAdminRoles))
			},
			"TargetSecondaries": {
				"NewSecondaryFrom":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchProduct":{
			"Versions": {
				"NewProductVersionBySeason":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchProductVersion":{
			"Target": {
				"NewOptionNoForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewOptionWithForm":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"NewOptionsCarryoverByParentVersion":access( full(merchAdminRoles), full(merchCreatorRoles)),
				"Copy":access(full(merchAdminRoles), full(merchCreatorRoles)),
				"Delete":access(full(merchAdminRoles))
			},
			"TargetSecondaries": {
				"NewSecondaryFrom":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"MerchOptionVersion":{
			"TargetSecondaries": {
				"NewSecondaryFrom":access( full(merchAdminRoles), full(merchCreatorRoles))
			}
		},
		"Style": {
			"StyleCandidates": {
				"SelectAsCandidate":access( full(merchProductVersionParticipant))
			}
		}
	});
});